"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _validator = require("validator");

var _uiKit = require("@devsta/ui-kit");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _getValueFromGenericInput = require("@devsta/get-value-from-generic-input");

var _EditOrganisationStage = _interopRequireDefault(require("../../EditOrganisationStage"));

var _validateOrganisation = _interopRequireDefault(require("../../../utils/validation/validateOrganisation"));

require("../styles/_invite-user.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var REQUIRED_USER_FIELDS = ['email'];
var isValidEmail = (0, _memoizeOne.default)(_validator.isEmail);

var InviteUser = /*#__PURE__*/function (_Component) {
  _inherits(InviteUser, _Component);

  function InviteUser(props) {
    var _this;

    _classCallCheck(this, InviteUser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InviteUser).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "updateInputField", (0, _lodash.default)(function (fieldName) {
      return function (result) {
        _this.setState(_defineProperty({}, fieldName, (0, _getValueFromGenericInput.getStringValueFromGenericInput)(result)));
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "handleSave", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, updateOrganisation, goToNextWizardStage, hasUpdatePermission, email, _ref2, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, updateOrganisation = _this$props.updateOrganisation, goToNextWizardStage = _this$props.goToNextWizardStage, hasUpdatePermission = _this$props.hasUpdatePermission;
              email = _this.state.email;

              if (hasUpdatePermission) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", void goToNextWizardStage());

            case 4:
              _this.setState({
                saving: true
              });

              _context.next = 7;
              return updateOrganisation({
                input: {
                  invitedUserEmail: email
                }
              });

            case 7:
              _ref2 = _context.sent;
              error = _ref2.error;

              if (error) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return", void goToNextWizardStage());

            case 11:
              _this.setState({
                saving: false
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "isDraftOrganisation", function () {
      var organisation = _this.props.organisation;
      return Boolean(organisation && organisation.status === 'DRAFT');
    });

    var invitedUserEmail = props.organisation.invitedUserEmail;
    _this.state = {
      email: invitedUserEmail || '',
      saving: false
    };
    return _this;
  }

  _createClass(InviteUser, [{
    key: "render",
    value: function render() {
      var hasUpdatePermission = this.props.hasUpdatePermission;
      var _this$state = this.state,
          email = _this$state.email,
          saving = _this$state.saving;
      return _react.default.createElement(_EditOrganisationStage.default, {
        title: "Invite an Organisation Administrator"
      }, _react.default.createElement("div", {
        className: "organisation-invite-user"
      }, _react.default.createElement(_uiKit.Input, {
        id: "email-input",
        placeholder: "Enter email",
        label: "Email*",
        validate: isValidEmail,
        onChange: this.updateInputField('email'),
        errorMessage: "Please enter a valid email address",
        defaultValue: email,
        disabled: !this.isDraftOrganisation() || !hasUpdatePermission
      }), _react.default.createElement(_uiKit.Button, {
        id: "submit-button",
        busy: saving,
        onClick: this.handleSave,
        disabled: !(this.isDraftOrganisation() && (0, _validateOrganisation.default)(this.state, REQUIRED_USER_FIELDS) && isValidEmail(email))
      }, hasUpdatePermission ? 'Save & Continue' : 'Continue')));
    }
  }]);

  return InviteUser;
}(_react.Component);

exports.default = InviteUser;